var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-tabs",
        {
          staticClass: "menuSettingsHeader",
          attrs: {
            centered: "",
            "icons-and-text": "",
            "show-arrows": "",
            "background-color": "transparent"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "blue" } }),
          _c(
            "v-tab",
            { attrs: { to: "/settings/users" } },
            [
              _vm._v(" " + _vm._s(_vm.$t("settingsMenu.users")) + " "),
              _c("v-icon", [_vm._v("fa-users")])
            ],
            1
          ),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { to: "/settings/cost-centre" } },
                [
                  _vm._v(" " + _vm._s(_vm.$t("settingsMenu.costCentre")) + " "),
                  _c("v-icon", [_vm._v("fa-vote-yea")])
                ],
                1
              )
            : _vm._e(),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { to: "/settings/user-substitute" } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("settingsMenu.userSubstitute")) + " "
                  ),
                  _c("v-icon", [_vm._v("fa-users-cog")])
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-tab",
            { attrs: { to: "/settings/role" } },
            [
              _vm._v(" " + _vm._s(_vm.$t("settingsMenu.role")) + " "),
              _c("v-icon", [_vm._v("fa-key")])
            ],
            1
          ),
          _c(
            "v-tab",
            { attrs: { to: "/settings/system-settings" } },
            [
              _vm._v(" " + _vm._s(_vm.$t("settingsMenu.systemSettings")) + " "),
              _c("v-icon", [_vm._v("fa-database")])
            ],
            1
          ),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { to: "/settings/workflow" } },
                [
                  _vm._v(" " + _vm._s(_vm.$t("settingsMenu.workflow")) + " "),
                  _c("v-icon", [_vm._v("merge_type")])
                ],
                1
              )
            : _vm._e(),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { to: "/settings/delegation-rate" } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("settingsMenu.delegationRate")) + " "
                  ),
                  _c("v-icon", [_vm._v("fa-hand-holding-usd")])
                ],
                1
              )
            : _vm._e(),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { to: "/settings/custom-webpage" } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("settingsMenu.customWebpage")) + " "
                  ),
                  _c("v-icon", [_vm._v("view_agenda")])
                ],
                1
              )
            : _vm._e(),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2 &&
          _vm.$store.getters["userProperties"].system_settings
            .is_delegation_task_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { to: "/settings/delegation-task" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("settingsMenu.delegationTaskEdit")) +
                      " "
                  ),
                  _c("v-icon", [_vm._v("assignment")])
                ],
                1
              )
            : _vm._e(),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { to: "/settings/vehicles" } },
                [
                  _vm._v(" " + _vm._s(_vm.$t("settingsMenu.vehicles")) + " "),
                  _c("v-icon", [_vm._v("directions_car")])
                ],
                1
              )
            : _vm._e(),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { to: "/settings/organizational-structure" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("settingsMenu.organizationStructure")) +
                      " "
                  ),
                  _c("v-icon", [_vm._v("fa-sitemap")])
                ],
                1
              )
            : _vm._e(),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_delegation_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { disabled: "", to: "/settings/exchange-rates" } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("settingsMenu.exchangeRates")) + " "
                  ),
                  _c("v-icon", [_vm._v("fa-dollar-sign")])
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-tab",
            { attrs: { to: "/settings/logs" } },
            [
              _vm._v(" " + _vm._s(_vm.$t("settingsMenu.logs")) + " "),
              _c("v-icon", [_vm._v("fa-list-ol")])
            ],
            1
          ),
          _vm.$store.getters["userProperties"].system_settings
            .is_module_travel_service_enabled === 2
            ? _c(
                "v-tab",
                { attrs: { to: "/settings/travel-service" } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("settingsMenu.travelService")) + " "
                  ),
                  _c("v-icon", [_vm._v("fa-globe")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }